export const LAYOUTS = {
  ONE_COLUMN: 'ONE_COLUMN',
  TWO_COLUMN: 'TWO_COLUMN',
  THREE_COLUMN: 'THREE_COLUMN',
  ONE_TWO_THIRDS_COLUMN: 'ONE_TWO_THIRDS_COLUMN',
  TWO_ONE_THIRDS_COLUMN: 'TWO_ONE_THIRDS_COLUMN',
  FOUR_COLUMN: 'FOUR_COLUMN'
};
export const VERTICAL_ALIGN = {
  BOTTOM: 'BOTTOM',
  MIDDLE: 'MIDDLE',
  TOP: 'TOP'
};
export const STACK = {
  NONE: 'NONE',
  LEFT_TO_RIGHT: 'LEFT_TO_RIGHT',
  RIGHT_TO_LEFT: 'RIGHT_TO_LEFT'
};
export const LAYOUT_LABELS_SHORT = {
  [LAYOUTS.ONE_COLUMN]: '1',
  [LAYOUTS.TWO_COLUMN]: '2',
  [LAYOUTS.THREE_COLUMN]: '3',
  [LAYOUTS.FOUR_COLUMN]: '4',
  [LAYOUTS.ONE_TWO_THIRDS_COLUMN]: '1/3 : 2/3',
  [LAYOUTS.TWO_ONE_THIRDS_COLUMN]: '2/3 : 1/3'
};
export const LAYOUT_COLUMNS = {
  [LAYOUTS.ONE_COLUMN]: [12],
  [LAYOUTS.TWO_COLUMN]: [6, 6],
  [LAYOUTS.THREE_COLUMN]: [4, 4, 4],
  [LAYOUTS.FOUR_COLUMN]: [3, 3, 3, 3],
  [LAYOUTS.ONE_TWO_THIRDS_COLUMN]: [4, 8],
  [LAYOUTS.TWO_ONE_THIRDS_COLUMN]: [8, 4]
};
export function getLayoutForSection(section) {
  const columnWidths = section.get('columns').map(col => col.get('width')).toArray();
  return Object.keys(LAYOUTS).find(layout => LAYOUT_COLUMNS[layout].every((columnWidth, index) => columnWidth === columnWidths[index]));
}